import { Box, Typography } from "@mui/material";
import React from "react";
import Plot from "react-plotly.js";

const PlotChartComponent = ({
  data,
  title,
  rangeData,
  xTitle = "Age Group",
  yTitle = "Fitness Percentile",
  height = "500px",
  width = "100%",
  groupBy = "age",
  valueKey = "",
  groupLabels = { "20's": [20, 30], "30's": [30, 40], "40's": [40, 50] },
  backColor,
}) => {
  const patientIDs = data?.map((item) => `Patient ID: ${item.patient_id}`);
  const groupedData = Object.keys(groupLabels).reduce((acc, label) => {
    acc[label] = [];
    return acc;
  }, {});

  data?.forEach((item) => {
    const value = item[valueKey];

    const groupLabel = Object.keys(groupLabels).find((label) => {
      const [min, max] = groupLabels[label];
      return item[groupBy] >= min && item[groupBy] < max;
    });
    if (groupLabel) groupedData[groupLabel].push(value);
  });

  const boxPlotData = Object.keys(groupedData).map((group) => {
    const groupValues = groupedData[group];

    return {
      type: "box",
      y: groupValues,
      name: group,
      boxpoints: "all",
      jitter: 0.5,
      pointpos: -1.8,
      marker: { color: "rgba(16, 16, 16, 0.6)" },
      line: { color: "#D5B98B" },
      hoverinfo: "text",
      text: data
        .filter((item) => {
          const [min, max] = groupLabels[group];
          return item[groupBy] >= min && item[groupBy] < max;
        })
        .map((item) => `Patient ID: ${item.patient_id}`),
    };
  });

  const allValues = data
    .map((item) => item[valueKey])
    .filter((v) => v !== null && v !== undefined);
  const minY = backColor
    ? 0
    : allValues.length
    ? Math.floor(Math.min(...allValues) / 5) * 5
    : 0;
  const maxY = backColor
    ? 100
    : allValues.length
    ? Math.ceil(Math.max(...allValues) / 5) * 5
    : 100;

  const backgroundShapes = rangeData?.map((range, index) => ({
    type: "rect",
    xref: "paper",
    yref: "y",
    x0: 0,
    x1: 1,
    y0: index === 0 ? range.min : rangeData[index - 1].max,
    y1: range.max,
    fillcolor: backColor ? range.color : "#fff",
    opacity: 0.15,
    line: { width: 0 },
  }));

  const layout = {
    title: { text: title, font: { size: 15, weight: 600 } },
    xaxis: {
      title: xTitle,
      tickmode: "array",
      tickvals: Object.keys(groupLabels).map((_, i) => i),
      ticktext: Object.keys(groupLabels),
    },
    yaxis: {
      title: yTitle,
      range: [minY, maxY],
      // dtick: 5,
      showgrid: true,
      gridcolor: "rgba(200, 200, 200, 0.5)",
    },

    shapes: backgroundShapes,
    margin: { l: 50, r: 10, b: 50, t: 50 },
    plot_bgcolor: "#FFFFFF",
    // paper_bgcolor: "#F7F7F7",
    showlegend: false,
    dragmode: false,
  };

  return (
    // <Box sx={{ width: "100%", height: "100%", margin: "0 auto" }}>
    <Plot
      data={boxPlotData}
      layout={layout}
      config={{ displayModeBar: false, responsive: true }}
      style={{ width, height }}
    />
    // </Box>
  );
};

export default PlotChartComponent;
